"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatesSelectionNavigator = void 0;
var React = __importStar(require("react"));
var date_fns_1 = require("date-fns");
var format_date_1 = require("./format-date");
var DatesSelectionNavigator = function (props) {
    var setNextMonth = function () { return props.changeShownDate((0, date_fns_1.addMonths)(props.currentFocusedDate, 1)); };
    var setPrevMonth = function () { return props.changeShownDate((0, date_fns_1.subMonths)(props.currentFocusedDate, 1)); };
    var setCalendarYear = function (year) { return function () { return props.changeShownDate((0, date_fns_1.setYear)(new Date(), year)); }; };
    React.useEffect(function () {
        if (props.focusedDate) {
            props.changeShownDate(props.focusedDate);
        }
        return function () {
            props.setFocusedDate(undefined);
        };
    }, [props.focusedDate]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "date-range__type-select align-items-center" },
            React.createElement("div", { className: "date-range__date-box flex-fill d-flex align-items-center" },
                React.createElement("div", { className: "date-range__date-box-number" },
                    React.createElement("strong", null, (0, format_date_1.formatDate)(props.startingDate, 'dd'))),
                React.createElement("div", { className: "date-range__date-box-rest" },
                    React.createElement("span", { className: "d-block" }, "Data przyjazdu"),
                    React.createElement("strong", { className: "date-range__date-box-rest-month d-block" }, (0, format_date_1.formatDate)(props.startingDate, 'MMMM')))),
            props.isPickingEndDate ? (React.createElement("div", { className: "date-range__type flex-fill text-center" },
                React.createElement("i", { className: "uil uil-arrow-up-right date-range__type-icon" }),
                "Data wyjazdu")) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "date-range__days-long" },
                    props.daysDiff,
                    " ",
                    props.stayDeclination),
                React.createElement("div", { className: "date-range__date-box flex-fill d-flex align-items-center justify-content-end" },
                    React.createElement("div", { className: "date-range__date-box-number" },
                        React.createElement("strong", null, (0, format_date_1.formatDate)(props.endingDate, 'dd'))),
                    React.createElement("div", { className: "date-range__date-box-rest" },
                        React.createElement("span", { className: "d-block" }, "Data wyjazdu"),
                        React.createElement("strong", { className: "date-range__date-box-rest-month d-block" }, (0, format_date_1.formatDate)(props.endingDate, 'MMMM'))))))),
        React.createElement("div", { className: "date-range__year-select overflow-scroll d-flex" }, props.seasons.map(function (year) { return (React.createElement("div", { key: year, className: "date-range__year cursor-pointer ".concat(props.isYearActive(year) ? 'is-active' : ''), onClick: setCalendarYear(year) }, year)); })),
        props.months === 1 && (React.createElement("div", { className: "date-range__month-select d-flex align-items-center" },
            React.createElement("i", { className: "uil uil-angle-left-b date-range__month-icon", role: "prev-icon", onClick: setPrevMonth }),
            React.createElement("span", { className: "flex-fill text-center date-range__month" }, (0, format_date_1.formatDate)(props.currentFocusedDate, 'LLLL yyyy')),
            React.createElement("i", { className: "uil uil-angle-right-b date-range__month-icon", role: "next-icon", onClick: setNextMonth }))),
        props.months === 2 && (React.createElement("div", { className: "d-flex" },
            React.createElement("div", { className: "date-range__month-select d-flex align-items-center w-50" },
                React.createElement("i", { className: "uil uil-angle-left-b date-range__month-icon", role: "prev-icon", onClick: setPrevMonth }),
                React.createElement("span", { className: "flex-fill text-center date-range__month" }, (0, format_date_1.formatDate)(props.currentFocusedDate, 'LLLL yyyy'))),
            React.createElement("div", { className: "date-range__month-select-spacer" }),
            React.createElement("div", { className: "date-range__month-select d-flex align-items-center w-50" },
                React.createElement("span", { className: "flex-fill text-center date-range__month" }, (0, format_date_1.formatDate)((0, date_fns_1.addMonths)(props.currentFocusedDate, 1), 'LLLL yyyy')),
                React.createElement("i", { className: "uil uil-angle-right-b date-range__month-icon", role: "next-icon", onClick: setNextMonth }))))));
};
exports.DatesSelectionNavigator = DatesSelectionNavigator;
